<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("edit") }} {{ $t("distributorDeduction") }}
        </div>
      </div>
    </div>
    <br />
    <div class="white-wrapper">
      <div class="row">
        <!-- DISTRIBUTOR -->
        <div class="col-md-6 mb-4">
          <custommultiselect
            v-model="distributorDeductions.distributor_id"
            :options="distributors"
            :selectLabel="''"
            :placeholder="$tc('distributor', 1)"
            label="d_company_name"
            isSingleId="d_id"
            @input="onSelectDistributorDeduction"
            :multiple="false"
            track-by="d_id"
          ></custommultiselect>
        </div>

        <!-- @select="onSelectDistributorMasterMovie($event, 'distributor_id')"
        @remove="onSelectDistributorMasterMovie($event, 'remove')"-->

        <div class="col-md-6 mb-4">
          <custommultiselect
            v-model="distributorDeductions.cinema_id"
            disabled
            :options="Cinemas"
            :selectLabel="''"
            :placeholder="$tc('cinema', 1)"
            label="cine_name"
            isSingleId="cine_id"
            @input="onSelectDistributorDeduction"
            :multiple="true"
            track-by="cine_id"
          ></custommultiselect>
        </div>

        <div class="col-md-6 mb-4">
          <custommultiselect
            v-model="distributorDeductions.movie_details_id"
            :options="DistributorMovies"
            :selectLabel="''"
            :placeholder="$tc('movie', 1)"
            label="movie_details"
            isSingleId="md_id"
            :multiple="false"
            track-by="md_id"
          ></custommultiselect>
        </div>
        <div class="col-lg-6 mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <datetime
                v-model="distributorDeductions.dd_date"
                type="date"
                class="theme-custom-date-time"
                :format="_DateFormat"
              ></datetime>
              <label class="active">{{ $t("date") }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(
            MultipleDeduction, MultipleDeductionIndex
          ) in multipleDeductions"
          :key="MultipleDeductionIndex"
          class="col-12 mb-4"
        >
          <div class="row mt-4">
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="MultipleDeduction.dd_deduction_label"
                    type="text"
                    placeholder="."
                  />
                  <label>{{ $t("deduction") + " label" }}</label>
                </div>

                <!-- <img src="@/assets/img/icons/question.svg" height="20" width="20" class="ml-2" :title="$t('label_distributionDeduction')" /> -->
              </div>
            </div>

            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="MultipleDeduction.dd_deduction_value"
                    type="number"
                    step="any"
                    placeholder="."
                  />
                  <label>{{ $t("deduction") }}&nbsp;{{ $t("value") }}</label>
                </div>
                <!-- <img src="@/assets/img/icons/question.svg" height="20" width="20" class="ml-2" :title="$t('deductionvalueDistributionDeduction')" /> -->
              </div>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <div>percentage is</div>
                <b-form-checkbox
                  class="j-checkbox ml-3"
                  v-model="MultipleDeduction.dd_is_percentage"
                  unchecked-value="N"
                  value="Y"
                  switch
                ></b-form-checkbox>
              </div>
            </div>

            <div class="col-md-4">
              <div class="row">
                <div class="col-md-9">
                  <custommultiselect
                    v-model="MultipleDeduction.selectedShow"
                    :options="Shows"
                    :selectLabel="''"
                    :placeholder="`${$t('show')} / ${$t('week')}`"
                    label="label"
                    isSingleId="id"
                    :multiple="false"
                    track-by="id"
                  ></custommultiselect>
                </div>
                <div class="col-md-3 align-self-center">
                  <button
                    v-if="MultipleDeductionIndex === 0"
                    @click="addMoreMultipleDeductions()"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>

                  <button
                    v-if="
                      MultipleDeductionIndex === 0 &&
                      multipleDeductions.length !== 1
                    "
                    @click="removeMultipleDeductions(MultipleDeductionIndex)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                  <button
                    v-if="MultipleDeductionIndex !== 0"
                    @click="removeMultipleDeductions(MultipleDeductionIndex)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button class="btn-black">{{ $t("reset") }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="distributor-deduction"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import DistributorService from "@/services/DistributorService";
import moment from "moment";

export default {
  data() {
    return {
      btenable: false,
      selectedDistributor: "",
      distributors: [],
      Cinemas: [],
      CinemasAllList: [],
      DistributorMovies: [],
      MoviesWithFormat: [],
      Shows: [
        {
          label: "Per show",
          id: 1,
        },
        {
          label: "Per week",
          id: 2,
        },
      ],
      distributorDeductions: {
        distributor_id: null,
        cinema_id: null,
        cinema_id_list: [],
        movie_details_id: null,

        dd_date: null,
        dd_is_active: "Y",
        created_by: null,
        created_at: null,
      },
      multipleDeductions: [
        {
          dd_id: null,
          dd_deduction_label: null,
          dd_deduction_value: null,
          selectedShow: null,
          dd_per_show: null,
          dd_per_week: null,
          dd_is_percentage: "N",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
    const { cinema_id, movie_details_id, dd_date, distributor_id } =
      this.$route.query;
    let payload = {
      cinema_id: cinema_id,
      movie_details_id: movie_details_id,
      dd_date: dd_date,
      distributor_id: distributor_id,
    };
    this.getSingleDistributionDeduction(payload);
    this.getDistributorsList(payload.distributor_id);
    this.getMoviesList(payload.cinema_id, payload.distributor_id);
  },
  mounted() {},
  methods: {
    getSingleDistributionDeduction: function (payload) {
      DistributorService.GetSingleDistributionDeduction(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.multipleDeductions = [];
              this.distributorDeductions = {
                ...data.Records[0],
                dd_date: moment(data.Records[0].dd_date).format(),
              };
              data.Records.map((x) => {
                // if (x.dd_per_show == "Y") {
                //   x["selectedShow"] = 1;
                // } else {
                //   x["selectedShow"] = 2;
                // }
                this.multipleDeductions.push({
                  dd_id: x.dd_id,
                  dd_deduction_label: x.dd_deduction_label,
                  dd_deduction_value: x.dd_deduction_value,
                  selectedShow: x.dd_per_show == "Y" ? 1 : 2,
                  dd_per_show: x.dd_per_show,
                  dd_per_week: x.dd_per_week,
                  dd_is_percentage: x.dd_is_percentage, // "N"
                });
              });
            }
          } else data && data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    onResetForm: function () {
      this.distributorDeductions = {
        distributor_id: null,
        cinema_id: null,
        cinema_id_list: [],
        movie_details_id: null,

        dd_date: null,
        dd_is_active: null,
        created_by: null,
        created_at: null,
      };
      this.multipleDeductions = [
        {
          dd_deduction_label: null,
          dd_deduction_value: null,
          selectedShow: null,
          dd_per_show: null,
          dd_per_week: null,
          dd_is_percentage: "N",
        },
      ];
    },
    onSelectDistributorDeduction: function (event, name) {
      if (
        this.distributorDeductions.distributor_id &&
        this.distributorDeductions.cinema_id_list.length > 0
      ) {
        this.distributorDeductions.cinema_id =
          this.distributorDeductions.cinema_id_list
            .map((x) => x.cine_id)
            .join(", ");
      }
      // if (this.distributorDeductions.distributor_id) {
      //   this.getDistributorDeductionsCinemasList(
      //     this.distributorDeductions.distributor_id
      //   );
      // }
    },
    getDistributorsList: function (distributor_ID) {
      let body = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.distributors = data.Records || [];
            data.Records.map((x) => {
              if (x.d_id == distributor_ID) {
                this.selectedDistributor = x.d_company_name;
              }
            });
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getDistributorDeductionsCinemasList: function (distributor_id) {
      DistributorService.GetDistributorDeductionsCinemas(distributor_id)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.Cinemas = [];
              data.Records.map((x) => {
                let cinema = this.CinemasAllList.filter(
                  (y) => String(y.cine_id) === String(x.cinema_id)
                );
                if (cinema.length > 0) {
                  this.Cinemas.push(cinema[0]);
                }
              });
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasAllList = data.Records;
            }
          } else data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    getMoviesList: function (cinema_ID, distributor_ID) {
      let payload = {
        distributor_id: distributor_ID,
        cinema_id: cinema_ID,
      };
      DistributorService.GetDistributorDeductionsMovies(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            data.Records.length > 0
              ? (this.DistributorMovies = data.Records)
              : "";
          } else data && data.message ? this.$toasted.show(data.message) : "";
        })
        .catch(this._CatchError);
    },
    OnFinalSubmit(redirect) {
      this.btenable = true;
      let payload = {
        ...this.distributorDeductions,
        deductions: this.multipleDeductions,
      };
      DistributorService.EditDistributorDeductions(payload)
        .then((response) => {
          this.btenable = false;
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.onResetForm();
            if (redirect) {
              this.$router.push({
                path: "/distributor/distributor-deduction",
              });
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    addMoreMultipleDeductions: function () {
      this.multipleDeductions.push({
        dd_id: null,
        dd_deduction_label: null,
        dd_deduction_value: null,
        selectedShow: null,
        dd_per_show: null,
        dd_per_week: null,
        dd_is_percentage: "N",
      });
    },
    removeMultipleDeductions: function (index) {
      this.multipleDeductions.splice(index, 1);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorDeduction/editDistributorDeduction.vue